import { render } from "./CustomAlert.vue?vue&type=template&id=4122e79a&scoped=true&ts=true"
import script from "./CustomAlert.vue?vue&type=script&lang=ts"
export * from "./CustomAlert.vue?vue&type=script&lang=ts"

import "./CustomAlert.vue?vue&type=style&index=0&id=4122e79a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/deployJob/project/music-teach/h5-internal-examination/code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4122e79a"]])

export default __exports__